/**
 * Created by hp on 2017/7/3.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {WKDialog, ImgTipsDialog} from '../../components';
import {WKOwnDialog} from '../wk'
import {ButtonArea, Button} from 'react-weui';
import qr from 'qr-encode';
import EventBus from '../../utils/bus'
import '../../styles/classroom/ClassroomCloseUp.css';

class ClassroomCloseUp extends Component {
    constructor() {
        super();
        this.handleRequestClose = this.handleRequestClose.bind(this);
        this.handleListenFirstRecord = this.handleListenFirstRecord.bind(this);
        this.handleListenLastRecord = this.handleListenLastRecord.bind(this);

        this.state = {
            isListen: false,
            deepperFocusQrcode: null,
            subscribed_retain: false
        }
    }

    componentWillMount() {
        const {lecture} = this.props;
        const messageId = localStorage.getItem('lastReadMessageId/' + lecture.id);
        if (messageId) {
            this.setState({isListen: true});
        }
    }

    componentDidMount() {
        if (!this.props.account.subscribed){
            try {
            EventBus.on('subscribed_retainInfo', (subscribed_retainIn) => {
                const subscribed_retain = subscribed_retainIn
                this.setState({
                    subscribed_retain: subscribed_retain
                })
                if (!subscribed_retain) {
                    axios.get(`/api/liveroom/${this.props.liveroom.id}/get_qrcode`, {
                        params: {
                            object_id: this.props.lecture.id,
                            object_type: 'fl_lecture'
                        }
                    })
                        .then(res => {
                            if (res.data.code === 0) {
                                this.setState({
                                    deepperFocusQrcode: res.data.data.qrcode_content
                                })
                            }
                        })
                   }
            })
        } catch(err) {
            console.log('subscribed_retainInfo eventBus error')
         }
        }
    }

    componentWillUnmount() {
        this.handleRequestClose();
        EventBus.off('subscribed_retainInfo')
    }

    handleRequestClose() {
        this.props.dispatch({type: 'CLASSROOM_HIDE_CLOSEUP_DIALOG'});
    }

    handleListenFirstRecord() {
        this.handleRequestClose();

        const {messageList} = this.props;
        let message = messageList.messages.filter((item) => {
            return item.type === 'voice';
        })[0];

        if (message) {
            this.props.dispatch({type: 'ML_SET_AUTOPLAY', payload: message.id});
            const el = document.getElementById('message_' + message.id);
            if (el) {
                this.context.classroomPage.scrollTo(el.offsetTop, false);
            }
        }
    }

    handleListenLastRecord() {
        this.handleRequestClose();

        const {lecture} = this.props;
        const messageId = localStorage.getItem('lastReadMessageId/' + lecture.id);
        if (messageId) {
            this.props.dispatch({type: 'ML_SET_AUTOPLAY', payload: messageId});
            const el = document.getElementById('message_' + messageId);
            if (el) {
                this.context.classroomPage.scrollTo(el.offsetTop, false);
            }
        }
    }
    
    render() {
        const {liveroom, qrcodes, account, showCloseUpDialog, lecture, isThisClassFakeClose, isThisClassHasAudio} = this.props;
        const {isListen, subscribed_retain} = this.state;

        const tsNow = parseInt(Date.now() / 1000, 10);
        if (lecture.start_timestamp > tsNow) {
            return null;
        }
        if (!isThisClassHasAudio) {
            return null;
        }
        if (isThisClassFakeClose) {
            return null
        }

        let buttons = [
            {
                label: '直接进入',
                type: 'default',
                onClick: () => {
                    this.handleRequestClose()
                }
            },
            {
                label: '从头收听',
                onClick: () => {
                    this.handleListenFirstRecord()
                }
            }
        ];

        if (isListen){
            buttons = [
                {
                    label: '直接进入',
                    type: 'default',
                    onClick: () => {
                        this.handleRequestClose()
                    }
                },
                {
                    label: '继续收听',
                    onClick: () => {
                        this.handleListenLastRecord()
                    }
                }
            ];
        }

        return (
            <div className="classroom-close-up">
                {showCloseUpDialog &&
                <WKOwnDialog
                    title='直播已结束'
                    show={true}
                    onRequestClose={this.handleRequestClose}
                    buttons={buttons}>

                    <p>课程可以反复收听</p>
                    {!account.subscribed && !subscribed_retain &&
                    <p className="content__qrcode"><img src={qr(this.state.deepperFocusQrcode)} alt="qrcode"/></p>
                    }

                    {!account.subscribed && !subscribed_retain ?
                        <p>扫描二维码接收新课动态</p>
                        :
                        null
                    }

                </WKOwnDialog>
                }

                <ImgTipsDialog />
            </div>
        )
    }
}

ClassroomCloseUp.contextTypes = {
    messageList: React.PropTypes.object,
    classroomPage: React.PropTypes.object,
};


export default connect((state) => ({
    role: state.classroom.role,
    account: state.account,
    qrcodes: state.classroom.qrcodes,
    lecture: state.classroom.lecture,
    liveroom: state.classroom.liveroom,
    messageList: state.messageList,
    showCloseUpDialog: state.classroom.showCloseUpDialog,
    imgTipsDialog: state.component.imgTipsDialog,
    isThisClassHasAudio: state.classroom.isThisClassHasAudio,
    isThisClassFakeClose: state.classroom.isThisClassFakeClose,
}))(ClassroomCloseUp)



// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomCloseUp.js